import { useLanguageContext } from "../../../context/LanguageContext";
import ParkingLocationPage from "../../../pages/parking_locations/parking_location/ParkingLocationPage";
import { useParkingLocationEditRouteValidator } from "../../validators/parking_locations/ParkingLocationEditRouteValidator";
import { RouteConfig } from "../RouteConfig";
import useParkingLocationsRouteConfig from "./ParkingLocationsRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useParkingLocationEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/parking_locations/:parking_location/edit")
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.parking_location"),
        },
      ])
    )
    .setValidator(useParkingLocationEditRouteValidator())
    .setPage(<ParkingLocationPage />)
    .setParent(useParkingLocationsRouteConfig());
}

export default useParkingLocationEditRouteConfig;
